import Emitter from 'component-emitter';
export var emitter = new Emitter();
